export type LogisticUnit = {
  lpn: string
  vendor_sscc: string | null
  container_type: number | null
  container_type_name: string | null
  container_type_code: string | null
  company: number | null
  company_name: string | null
  parent: number | null
  parent_lpn: string | null
  location: number
  location_barcode: string
  state: string
  gross_weight_kg: string | null
  length_cm: string | null
  width_cm: string | null
  height_cm: string | null
  created: string
  updated: string
  total_quantity: number
  contents_count: number
}

export type InventoryItem = {
  id: number
  variant_sku: string
  variant_barcode: string
  lot_number: string | null
  on_hand: number
  reserved: number
  available: number
  product_variant: number
  location: number
  location_barcode: string
}

export type LogisticUnitDetail = LogisticUnit & {
  contents: InventoryItem[]
  children: LogisticUnit[]
}

export type LogisticUnitTransaction = {
  id: number
  logistic_unit: number
  transaction_type: string
  transaction_type_display: string
  from_location: number | null
  from_location_barcode: string | null
  to_location: number | null
  to_location_barcode: string | null
  from_parent: number | null
  from_parent_lpn: string | null
  to_parent: number | null
  to_parent_lpn: string | null
  ship_notice: number | null
  order: number | null
  metadata: any
  user: number | null
  user_username: string | null
  comment: string | null
  created: string
}

export type ContainerType = {
  id: number
  code: string
  name: string
  description: string
  max_weight_kg: string | null
  length_cm: string | null
  width_cm: string | null
  height_cm: string | null
  nestable: boolean
  reusable: boolean
  is_active: boolean
}

// ── Shared display constants ────────────────────────────────────────────────
// Used across containers/index.tsx, container/index.tsx, container/children-tab.tsx

export const STATE_COLOR_MAP: Record<string, string> = {
  created: 'blue',
  in_stock: 'green',
  empty: 'silver',
  in_transit: 'yellow',
  retired: 'red',
}

export const STATE_DISPLAY_MAP: Record<string, string> = {
  created: 'Created',
  in_stock: 'In Stock',
  empty: 'Empty',
  in_transit: 'In Transit',
  retired: 'Retired',
}
